import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BusinessSwitcher from './BusinessSwitcher';
import ThemeToggle from './ThemeToggle';
import { useAuth } from '../context/AuthContext';

const ADMIN_ITEMS = [
  { to: '/users', label: 'Users', gate: 'users.manage' },
  { to: '/permissions', label: 'Roles & Permissions', gate: 'permissions.manage' },
  { to: '/audit', label: 'Audit log', gate: 'audit.view' },
  { to: '/import', label: 'Import', gate: 'data.import' },
  { to: '/export', label: 'Export', gate: 'data.export' },
  { to: '/settings/accounts', label: 'Chart of accounts', adminOnly: true },
  { to: '/settings/business', label: 'Business profile', adminOnly: true },
  { to: '/settings/payments', label: 'Payments (Stripe)', adminOnly: true },
  { to: '/settings/backups', label: 'Backups', adminOnly: true },
  { to: '/w9', label: 'W-9 forms', adminOnly: true },
];

export default function TopBar() {
  const { user, logout, can } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [adminOpen, setAdminOpen] = useState(false);
  const ref = useRef(null);
  const adminRef = useRef(null);

  useEffect(() => {
    function onDocClick(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
      if (adminRef.current && !adminRef.current.contains(e.target)) setAdminOpen(false);
    }
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  const name = user?.name || user?.email || 'Account';
  const email = user?.email || '';
  const initials = name.split(' ').map((p) => p[0]).slice(0, 2).join('').toUpperCase();

  const adminItems = ADMIN_ITEMS.filter((i) => (i.adminOnly ? user?.role === 'admin' : can(i.gate)));

  return (
    <header className="topbar">
      <BusinessSwitcher />

      <div className="topbar__actions">
        <a className="btn btn--sm field-btn" href="/field" title="Open field service mode">
          <span aria-hidden="true">🛠️</span> Field service
        </a>

        {adminItems.length > 0 && (
          <div className="topbar__right" ref={adminRef}>
            <button className="btn btn--sm" onClick={() => setAdminOpen((v) => !v)} aria-haspopup="menu" aria-expanded={adminOpen}>
              Admin ▾
            </button>
            {adminOpen && (
              <div className="usermenu" role="menu">
                {adminItems.map((item) => (
                  <button key={item.to} className="usermenu__item" role="menuitem"
                    onClick={() => { setAdminOpen(false); navigate(item.to); }}>
                    {item.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        )}

        <ThemeToggle />
        <div className="topbar__right" ref={ref}>
          <button className="usermenu__btn" onClick={() => setOpen((v) => !v)} aria-haspopup="menu" aria-expanded={open}>
            <span className="avatar">{initials}</span>
          </button>
          {open && (
            <div className="usermenu" role="menu">
              <div className="usermenu__head">
                <div className="usermenu__name">{name}</div>
                {email && <div className="usermenu__email">{email}</div>}
              </div>
              <button className="usermenu__item" role="menuitem" onClick={() => { window.location.href = '/field'; }}>Field mode</button>
              <button className="usermenu__item" role="menuitem" onClick={logout}>Sign out</button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
